// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"BannerE_TheComp__oq8wE"};